/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /* Session 7 (1 Sep 2026): Yotpo star rating click -> scroll to the reviews widget.
     The Yotpo "Clickable star rating" setting is ON, but the star block renders
     Yotpo's legacy bottomline markup whose own scroll code cannot find the
     new-style reviews widget (#yotpo-reviews-main-widget) on this store, so the
     click did nothing. This delegated handler does the jump instead.
     Rollback: remove this block and re-comment the custom.js include in layout/theme.liquid. */
  document.addEventListener('click', function (e) {
    var star = e.target.closest && e.target.closest('.yotpo-bottomline.star-clickable');
    if (!star) return;
    var target = document.querySelector('#yotpo-reviews-main-widget, .yotpo-widget-main-reviews, .yotpo-main-widget');
    if (target) {
      e.preventDefault();
      target.style.scrollMarginTop = '90px';
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, true);

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
